import { Injectable } from "@angular/core";
import { NAVIGATE_ROUTES } from "../../global/constants";
import { ApiService } from "../api-service/api.service";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  apiEndPoint = NAVIGATE_ROUTES;
  private dashRefresh: BehaviorSubject<any> = new BehaviorSubject<any>("");
  private eligibilityRequest: Promise<any> | null = null;
  dashRefresh$: Observable<any> = this.dashRefresh.asObservable();
  constructor(private apiService: ApiService) {}

  async getDashboardSummary(start: any, end: any): Promise<Observable<any>> {
    let res: any[] = [];
    const url = `${this.apiEndPoint.DASHBOARD_SUMMARY}?start_date=${start}&end_date=${end}`;
    await this.apiService.get(url).then((resData: any) => {
      res = resData;
    });
    return of(res);
  }

  async getTodayTaskSummary(start: any, end: any): Promise<Observable<any>> {
    let res: any[] = [];
    const url = `${this.apiEndPoint.DASHBOARD_TODAY_SUMMARY}?start_date=${start}&end_date=${end}`;
    await this.apiService.get(url).then((resData: any) => {
      res = resData;
    });
    return of(res);
  }

  async getPrioritySummary(start: any, end: any): Promise<Observable<any>> {
    let res: any[] = [];
    const url = `${this.apiEndPoint.DASHBOARD_PRIORITY}?start_date=${start}&end_date=${end}`;
    await this.apiService.get(url).then((resData: any) => {
      res = resData;
    });
    return of(res);
  }
  getDashRefresh(dashRefresh: any) {
    this.dashRefresh.next(dashRefresh);
  }

  async getEligibility(): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_ELIGIBILITY}`;
    if (!this.eligibilityRequest) {
      this.eligibilityRequest = this.apiService
        .get(url)
        .then((resData: any) => resData)
        .finally(() => {
          this.eligibilityRequest = null;
        });
    }

    const res = await this.eligibilityRequest;
    return of(res);
  }

  async getLastCheckInOutDetails(): Promise<Observable<any>> {
    let res: any[] = [];
    const url = `${this.apiEndPoint.GET_LAST_CHECK_IN_OUT_DETAILS}`;
    await this.apiService.get(url).then((resData: any) => {
      res = resData;
    });
    return of(res);
  }

  async userCheckInOut(data: any) {
    let res: any = [];
    const url = this.apiEndPoint.CHECK_IN_FACE;
    await this.apiService.post(url, data).then((resdata: any) => {
      res = [];
      res.push(resdata);
    });
    return of(res);
  }

  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable((observer) => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position);
            observer.complete();
          },
          (error) => observer.error(error),
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      } else {
        observer.error("Geolocation is not supported by this browser.");
      }
    });
  }
}
